import {MaterialDateLocaleProvider} from "./factories/MaterialDateLocaleProvider";
import {AngularMaterialConfigurationModuleConfiguration} from "./MaterialConfigurationsModuleConfiguration";

AngularMaterialConfigurationModuleConfiguration
    .createNewModule()
    .config(MaterialDateLocaleProvider.instance);